/**
 * All services state definitions
 */

import * as Activity from './activity/state';
import * as App from './app/state';
import * as Table from './table/state';
import * as Grid from './grid/state';
import * as Form from './form/state';
import * as Auth from './auth/state';
import * as Booking from './booking/state';
import * as Connect from './connect/state';
import * as Manifest from './manifest/state';
import * as Map from './map/state';
import * as Onboarding from './onboarding/state';
import * as Notification from './notification/state';

const $state = {
  Activity,
  App,
  Table,
  Grid,
  Form,
  Auth,
  Booking,
  Connect,
  Manifest,
  Map,
  Onboarding,
  Notification,
};

export default $state;
